import i18n from "@/i18n";
import { nextTick } from "vue";
import { setDefaultOptions } from "date-fns";
import { ru, enGB } from "date-fns/locale";
import { COUNTRIES } from "@/package/global-constants/countries-list";
import { getCurrentCountryCode } from "@/package/global-helpers/country-helper";

const Translate = {
  get supportedSystemLocales() {
    return COUNTRIES[getCurrentCountryCode()].supportedLocales;
  },

  isLocaleSupported(locale: string) {
    return Translate.supportedSystemLocales.includes(locale);
  },

  getUserSystemLocale() {
    const locale =
      window.navigator.language ||
      COUNTRIES[getCurrentCountryCode()].defaultLocale;

    return locale.split("-")[0];
  },

  getSavedLocale() {
    const savedLocale = localStorage.rcOfficeLocale;

    if (Translate.isLocaleSupported(savedLocale)) {
      return savedLocale;
    }

    return null;
  },

  initUserLocale() {
    const userSavedLocale = Translate.getSavedLocale();

    if (userSavedLocale) {
      Translate.switchLanguage(userSavedLocale);
      return;
    }

    const getUserSystemLocale = Translate.getUserSystemLocale();

    if (Translate.isLocaleSupported(getUserSystemLocale)) {
      Translate.switchLanguage(getUserSystemLocale);
      return;
    }

    Translate.switchLanguage(COUNTRIES[getCurrentCountryCode()].defaultLocale);
  },

  async switchLanguage(newLocale: string) {
    await Translate.loadLocaleMessages(newLocale);
    i18n.global.locale = newLocale;
    (document.querySelector("html") as HTMLHtmlElement).setAttribute(
      "lang",
      newLocale
    );
    setDefaultOptions({
      locale: newLocale === "ru" ? ru : enGB,
    });
    localStorage.setItem("rcOfficeLocale", newLocale);
  },

  async loadLocaleMessages(locale: string) {
    if (!i18n.global.availableLocales.includes(locale)) {
      const messages = await import(`./locales/${locale}.json`);
      i18n.global.setLocaleMessage(locale, messages);
    }

    return nextTick();
  },
};

export default Translate;
